import React from "react";
import Link from "next/link";
import { Button } from "@/components/common/Button";
import style from "./CTA.module.scss";
const CTATablet = () => {
  return <div className={style.cta_tablet} data-sentry-component="CTATablet" data-sentry-source-file="CTATablet.tsx">
      <p className={style.cta_text}>Get your Website QR Code easily!</p>
      <Link href={"/"} data-sentry-element="Link" data-sentry-source-file="CTATablet.tsx">
        <Button title={"Generate a QR Code"} variant="outline_primary" className={style.cta_tablet__btn} data-sentry-element="Button" data-sentry-source-file="CTATablet.tsx" />
      </Link>
    </div>;
};
export default CTATablet;